export const sizes = {
    h1: 42,
    h2: 36,
    h3: 26,
    h4: 22,
    h5: 18,
    h6: 16
};
